import { colors } from 'pages/new-questions/styles/common';
import styled from 'styled-components';

export const BadgetWrongRightAnswer = styled.div<{ className: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  width: fit-content;
  height: 28px;
  gap: 6px;
  padding: 2px 15px;
  border-radius: 50px;

  > p {
    font-family: Manrope, sans-serif;
    font-weight: 700;
    font-style: Bold;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 3%;
    text-align: center;
    vertical-align: middle;
    color: ${colors.white};
  }

  &.is-correct {
    background-color: ${colors.green};
  }

  &.is-incorrect {
    background-color: ${colors.red};
  }
`;
